import { RemoveUSPModal } from '@forwardflow/modals/RemoveUSPModal'
import Icon from '@forwardflow/ui/Icons'
import { message, Popconfirm } from 'antd'

export const USPListItem = ({
   title,
   description,
   onClick,
   onDelete,
   isLastUSP,
}: {
   title: string
   description: string
   onClick: () => void
   onDelete: () => void
   isLastUSP: boolean
}) => {
   const handleDelete = () => {
      if (isLastUSP) {
         message.warning('At least one Campaign USP is required')
         return
      }
      onDelete()
   }
   return (
      <>
         <div className="flex flex-col gap-3 px-10 py-5 bg-primary/10">
            <div className="flex items-center justify-between">
               <p className="text-[14px] font-medium">{title}</p>
               <div className="flex items-center gap-x-3">
                  <div onClick={onClick}>
                     <Icon
                        name="Edit"
                        className="mx-1 transition-all scale-125 opacity-50 cursor-pointer hover:opacity-100"
                     />
                  </div>
                  <div>
                     <Popconfirm
                        title={'Delete the USP'}
                        description={'Are you sure to delete this USP?'}
                        onConfirm={handleDelete}
                        okText="Yes"
                        cancelText="No"
                        overlayClassName="ff-popconfirm"
                     >
                        <div>
                           <Icon
                              name="Delete"
                              className="transition-all cursor-pointer opacity-70 fill-danger hover:opacity-100"
                           />
                        </div>
                     </Popconfirm>
                  </div>
               </div>
            </div>
            <p className="text-[12px] text-white/70 gradient-text">
               {description}
            </p>
         </div>
         <RemoveUSPModal onDelete={handleDelete} />
      </>
   )
}
